import type { Faq as FaqType } from '@ria-client/supergraph/base/types';
import { useId } from 'react';
import { StructuredContentRenderer } from '../renderer';
import { Faq } from './Faq';

export interface FaqSectionProps {
  faqs?: FaqType[];
  // Page-level section passes "faq" (TOC anchor); FAQ nodes omit it to avoid duplicate ids.
  headingId?: string;
  className?: string;
}

export function FaqSection({ faqs, headingId, className }: FaqSectionProps) {
  const generatedId = useId();
  const items = (faqs ?? []).filter(faq => faq.question && faq.answer);
  if (!items.length) return null;
  const id = headingId ?? generatedId;

  return (
    <section
      aria-labelledby={id}
      className={className}
      data-testid={headingId ? 'faqs-section' : undefined}
    >
      <h2 className="typography-text-large-bold mb-4 font-bold" id={id}>
        Frequently asked questions
      </h2>
      <Faq
        faqs={items.map(faq => ({
          question: faq.question,
          answer: <StructuredContentRenderer doc={faq.answer} />,
        }))}
      />
    </section>
  );
}
